import { z } from "zod";

export const AddCampagneDTOQuerySchema = z.object({
  nom: z
    .string({ required_error: "La réference de la campagne est requis." })
    .min(1, { message: "Le nom de la campagne ne peut pas être vide." }),
  region: z
    .string({ required_error: "La région est requise." })
    .min(1, { message: "La région ne peut pas être vide." }),
  typeCampagne: z
    .string({ required_error: "Le type de campagne est requis." })
    .min(1, { message: "Le type de campagne ne peut pas être vide." }),
  objectif: z
    .string({ required_error: "L'objectif de la campagne est requis." })
    .min(1, { message: "L'objectif ne peut pas être vide." }),
  dateDebut: z
    .string({ required_error: "La date de début est requise." })
    .min(5, { message: "La date de début est incorrect." }),
  dure: z
    .number({
      invalid_type_error: "La durée doit être un nombre.",
    })
    .min(1, { message: "La durée doit être un nombre supérieur à 0." })
    .int({ message: "L'objectif doit contenir uniquement des chiffres." }),
  estimationEleveur: z
    .number({
      required_error: "L'estimation des éleveurs est requise.",
      invalid_type_error: "L'estimation doit être un nombre.",
    })
    .optional(),

  objectifCouverture: z
    .number({
      required_error: "L'objectif de couverture est requis.",
      invalid_type_error: "L'objectif doit être un nombre.",
    })
    .int({ message: "L'objectif doit contenir uniquement des chiffres." })
    .min(1, {
      message: "L'objectif de couverture ne peut pas être inférieur à 1.",
    })
    .max(100, {
      message: "L'objectif de couverture ne peut pas être supérieur à 100.",
    }),
});

export const UpdateCampagneDTOQuerySchema = z.object({
  reference: z.string({
    required_error: "La référence de la campagne est requise.",
  }),
  nom: z
    .string({ required_error: "Le nom de la campagne est requis." })
    .min(1, { message: "Le nom de la campagne ne peut pas être vide." }),
  region: z
    .string({ required_error: "La région est requise." })
    .min(1, { message: "La région ne peut pas être vide." }),
  typeCampagne: z
    .string({ required_error: "Le type de campagne est requis." })
    .min(1, { message: "Le type de campagne ne peut pas être vide." }),
  objectif: z
    .string({ required_error: "L'objectif de la campagne est requis." })
    .min(1, { message: "L'objectif ne peut pas être vide." }),
  dateDebut: z.string({ required_error: "La date de début est requise." }),
  dure: z
    .number({
      required_error: "La durée est requise.",
      invalid_type_error: "La durée doit être un nombre.",
    })
    .min(1, { message: "La durée doit être un nombre supérieur à 0." }),
  estimationEleveur: z
    .number({
      invalid_type_error: "L'estimation doit être un nombre.",
    })
    .optional(),
  objectifCouverture: z
    .number({
      required_error: "L'objectif de couverture est requis.",
      invalid_type_error: "L'objectif doit être un nombre.",
    })
    .min(0, { message: "L'objectif de couverture ne peut pas être négatif." }),
  draft: z.boolean({
    required_error: "Le champ brouillon de la campagne est requis.",
  }),
  shelve: z.boolean({
    required_error: "Le champ suspendu de la campagne est requis.",
  }),
});

export const GetCampagneQuerySchema = z.string({
  required_error: "Le type est requis",
  invalid_type_error: "Le type doit être une chaine de caractères",
});

export const DisableCampagneDTOQuerySchema = z.object({
  referennce: z.string(),
  suspendre: z.boolean(),
});
